function FilterAufaDocketsData({ data, openNumDocket }) {

    const getStatusDescription = (statusCode) => {
        switch (statusCode) {
            case 0:
                return 'שמורה ל24 שעות';
            case 1:
                return 'הזמנה סגורה';
            case 2:
                return 'שולם דמי רישום';
            case 3:
                return 'הזמנה נפלה';
            case 5:
                return 'הזמנה חדשה';
            default:
                return 'סטטוס לא ידוע';
        }
    };


    return (
        <div className="InvoicesListTable" style={{ backgroundColor: ' #f0f0f0', height: 'calc(100% - 50px)', overflowY: 'auto', overflowX: 'auto', textAlign: 'center' }}>
            {
                Object.keys(data).length > 0 ?
                    <table style={{ width: '100%', tableLayout: 'fixed' }}>
                        <thead style={{ position: 'sticky', top: 0, backgroundColor: ' #f2f2f2' }}>
                            <tr>
                                {["מס' הזמנה", "מס' דוקט", "מספר טיסות", 'מספר נ"פ', "מספר נוסעים", "סטטוס", "עובד", "משרד", 'סה"כ', 'תאריך']
                                    .map((value, key) => (
                                        <th key={key} style={{ padding: '10px', borderBottom: '1px solid #ccc', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', maxWidth: '150px' }}>                            {value} </th>
                                    ))}
                            </tr>
                        </thead>

                        <tbody>
                            {


                                Object.values(data).map((value, key) => (

                                    <tr key={key}>
                                        <td key={1}>{value.aufa_id}</td>
                                        <td key={2} className="docket_number" onClick={() => openNumDocket(value.docket_id)}> {value.docket_id} </td>
                                        <td key={3}> {value.flights} </td>
                                        <td key={4}> {value.travels} </td>
                                        <td key={5}> {value.passengers} </td>
                                        <td key={6}>{getStatusDescription(value.status)}</td>
                                        <td key={7}> {value.worker} </td>
                                        <td key={8}>{value.office}</td>
                                        <td key={8}> {value.totalPrice} </td>
                                        <td key={9}>{value.date}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    :
                    <p className={"no-results"}>אין תוצאות</p>
            }
        </div>
    )
}


export default FilterAufaDocketsData;